//@ts-nocheck
import { useContext, useRef, useState } from "react";
import { Typography } from "mobily-ui-library/lib";
import { useTranslation } from "react-i18next";

import Store from "../Store/Store";
import StoreCluster from "../StoreCluster/StoreCluster";
import StoreLoader from "../Store/StoreLoader/StoreLoader";
import { getStoreLocator } from "../../api/api";
import { Error } from "../../util/Util";
import { GlobalContext } from "../../context/GlobalContext";
import Loader from "../Loader/Loader";
import { useWindowSize } from "../../util/WindowResize";
import ReactDependentScript from "react-dependent-script";
import scriptLoader from "react-async-script-loader";

import "./Home.scss";

type HomeProps = {
  rtl: boolean;
};

const win: any = window;
const key = window.location.origin.includes('mobily.com.sa') ? "AIzaSyCIlebu49-VMvif6YpTGm-BMXBojIZoiBg" : "AIzaSyDtKbJ8frTCqg4LsSfO0GDPla_tmaO5Pmg";

function Home(props: HomeProps) {
  const { rtl } = props;
  const { t } = useTranslation();
  const center = { lat: 24.7135517, lng: 46.6752957 };
  const [storeData, setStoreData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [mode, setMode] = useState(false);
  const [stLoading, setStLoading] = useState(false);
  const { state, dispatch }: any = useContext(GlobalContext);
  const { width } = useWindowSize();
  const childRef: any = useRef();

  const handleAddress = (dimension: any, location: any) => {
    setStLoading(true)
    if (location === "all") {
      setMode(true);
      getStoreLocator(location)
        .then((res) => {
          if (res.status === 200 && res.data.data.mobilyStores.length > 0) {
            setStoreData(res.data.data.mobilyStores);
            setStLoading(false)
          } else {
            setStoreData([]);
            setStLoading(false);
            Error(rtl ? res.data.status.arabicDetail : res.data.status.englishDetail)
          }
        })
        .catch((err) => Error(err));

    } else {
      const data: any = {
        cityName: location,
        lat: dimension.lat,
        lon: dimension.lng,
      };

      getStoreLocator(data)
        .then((res) => {
          if (res.status === 200 && res.data.data.mobilyStores.length > 0) {
            setMode(false);
            setStoreData(res.data.data.mobilyStores);
            setStLoading(false)
          } else {
            handleAddress(center, 'all');
            setMode(false);
          }
        })
        .catch((err) => Error(err));
    }
  };

  const handleCheckedChange = () => {
    setChecked(!checked);
  };

  let storeList: any = storeData;

  if (checked) {
    storeList = storeData.filter((store: any) => {
      return rtl ? store.storeStatus.label.ar === "مفتوح" : (store.storeStatus.label.en.toLowerCase() === "open");
    });
  }

  const handleListClick = (index) => {
    const refValue = childRef.current;
    refValue.listItemClick(index)
  }

  return (
    <>
      <div className={rtl ? "container Home__Container Home__arbaic" : "container Home__Container"}>
        <div className="row">
          <Typography rtl={rtl} className="HC__title">
            {t("Store_title")}
          </Typography>
          <Typography rtl={rtl} className="HC__subTitle">
            {t("Store_subtitle")}
          </Typography>
          <div className="HC__StoreContainer">
            {stLoading && <StoreLoader stLoading={stLoading} />}
            <Store
              rtl={rtl}
              checked={checked}
              storeList={storeList}
              handleCheckedChange={handleCheckedChange}
              handleListClick={handleListClick}
            />
            {/* <ReactDependentScript scripts={[`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`]}>
             
            </ReactDependentScript> */}

            <StoreCluster
              ref={childRef}
              checked={checked}
              storeData={storeList}
              rtl={rtl}
              dispatch={dispatch}
              center={center}
              handleAddress={handleAddress}
              width={width}
              t={t}
              mode={mode}
              {...props}
            />
          </div>
        </div>
      </div>

      <Loader loading={state.loader} />
    </>
  );
}

export default scriptLoader(`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&region=${win["lang"]}`)(Home);
